import { Badge } from '@/components/atoms/badge';
import type { ItemType } from '@/types/pricebook';
import { ITEM_TYPE_LABELS } from '@/types/pricebook';
import { TYPE_BADGE_CONFIG } from '@/components/organisms/pricebook/support/pricebook-helpers';

export function ItemTypeBadge({ type, dynamic = false }: { type: ItemType; dynamic?: boolean }) {
  const config = TYPE_BADGE_CONFIG[type] ?? TYPE_BADGE_CONFIG.service;
  const Icon = config.icon;
  return (
    <>
      <Badge variant="secondary" className={`capitalize text-xs ${config.className}`}>
        <Icon size={10} className="mr-1 inline" />
        {ITEM_TYPE_LABELS[type] ?? type}
      </Badge>
      {/* Two services priced by completely different rules read as the same
          "Service" in every list, and which one an item is decides whether its
          price is a figure someone typed or one the labor lines and parts
          produce. The detail page says "Priced by · Dynamic pricing"; that fact
          is only knowable there, one item at a time. */}
      {dynamic && (
        <Badge
          variant="outline"
          className="ml-1 text-xs font-normal text-muted-foreground"
          title="Priced from labor and parts, not a typed price"
        >
          Dynamic
        </Badge>
      )}
    </>
  );
}
